import FolderIcon from "@mui/icons-material/FolderRounded";
import DownloadIcon from "@mui/icons-material/SaveAltRounded";
import {
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { yellow } from "@mui/material/colors";
import FileIcon from "@entrilia/shared/components/FileIcon";
import TableWithActions from "@entrilia/shared/components/TableWithActions";
import { formatFileSize, getFileExtension } from "@entrilia/shared/utilities/fileHelper";
import type { DataImportFileContainerInfo } from "../../../../api/types/dataImportTypes";
import type { FileInfo } from "../../../../api/types/fileTypes";

interface Props {
  files: FileInfo[];
  fileContainers?: DataImportFileContainerInfo[];
  onDownloadFile: (fileDataCatalogueId: string) => void;
  showFileSize?: boolean;
  downloadingFileId?: string;
}

const ImportFilesTable = ({ files, fileContainers, onDownloadFile, showFileSize, downloadingFileId }: Props) => {
  return (
    <Paper variant="outlined" sx={{ width: "100%" }}>
      <TableContainer>
        <TableWithActions sx={{ "& .MuiTableRow-root": { "&:last-child": { td: { borderBottom: 0 } } } }}>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              {showFileSize && <TableCell sx={{ width: 120 }}>Size</TableCell>}
              <TableCell sx={{ width: 64 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {files.map((fileInfo) => (
              <TableRow key={fileInfo.fileName}>
                <TableCell>
                  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                    <FileIcon fileExtension={getFileExtension(fileInfo.fileName)} />
                    <Typography noWrap>{fileInfo.fileName}</Typography>
                  </Stack>
                </TableCell>
                {showFileSize && <TableCell>{formatFileSize(fileInfo.fileSize)}</TableCell>}
                <TableCell>
                  <IconButton
                    onClick={() => onDownloadFile(fileInfo.catalogueId)}
                    disabled={downloadingFileId === fileInfo.catalogueId}
                  >
                    {downloadingFileId === fileInfo.catalogueId ? (
                      <CircularProgress color="secondary" size={20} />
                    ) : (
                      <DownloadIcon />
                    )}
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {(fileContainers ?? []).map((fileContainer) => (
              <TableRow key={fileContainer.id}>
                <TableCell>
                  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                    <FolderIcon sx={{ color: yellow[600] }} />
                    <Typography noWrap>{fileContainer.containerName}</Typography>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableWithActions>
      </TableContainer>
    </Paper>
  );
};

export default ImportFilesTable;
